/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliveryAreas200ResponseInnerGeometry } from './GetDeliveryAreas200ResponseInnerGeometry';
import {
    GetDeliveryAreas200ResponseInnerGeometryFromJSON,
    GetDeliveryAreas200ResponseInnerGeometryFromJSONTyped,
    GetDeliveryAreas200ResponseInnerGeometryToJSON,
    GetDeliveryAreas200ResponseInnerGeometryToJSONTyped,
} from './GetDeliveryAreas200ResponseInnerGeometry';
import type { GetDeliveryAreas200ResponseInnerType } from './GetDeliveryAreas200ResponseInnerType';
import {
    GetDeliveryAreas200ResponseInnerTypeFromJSON,
    GetDeliveryAreas200ResponseInnerTypeFromJSONTyped,
    GetDeliveryAreas200ResponseInnerTypeToJSON,
    GetDeliveryAreas200ResponseInnerTypeToJSONTyped,
} from './GetDeliveryAreas200ResponseInnerType';

/**
 * 
 * @export
 * @interface UpdateDeliveryAreaRequest
 */
export interface UpdateDeliveryAreaRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDeliveryAreaRequest
     */
    name?: string;
    /**
     * 
     * @type {GetDeliveryAreas200ResponseInnerType}
     * @memberof UpdateDeliveryAreaRequest
     */
    type?: GetDeliveryAreas200ResponseInnerType;
    /**
     * 
     * @type {GetDeliveryAreas200ResponseInnerGeometry}
     * @memberof UpdateDeliveryAreaRequest
     */
    geometry?: GetDeliveryAreas200ResponseInnerGeometry;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeliveryAreaRequest
     */
    deliveryFee?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeliveryAreaRequest
     */
    deliveryExtraMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeliveryAreaRequest
     */
    minimumBasket?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDeliveryAreaRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeliveryAreaRequest
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeliveryAreaRequest
     */
    color?: string;
}

/**
 * Check if a given object implements the UpdateDeliveryAreaRequest interface.
 */
export function instanceOfUpdateDeliveryAreaRequest(value: object): value is UpdateDeliveryAreaRequest {
    return true;
}

export function UpdateDeliveryAreaRequestFromJSON(json: any): UpdateDeliveryAreaRequest {
    return UpdateDeliveryAreaRequestFromJSONTyped(json, false);
}

export function UpdateDeliveryAreaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDeliveryAreaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : GetDeliveryAreas200ResponseInnerTypeFromJSON(json['type']),
        'geometry': json['geometry'] == null ? undefined : GetDeliveryAreas200ResponseInnerGeometryFromJSON(json['geometry']),
        'deliveryFee': json['deliveryFee'] == null ? undefined : json['deliveryFee'],
        'deliveryExtraMinutes': json['deliveryExtraMinutes'] == null ? undefined : json['deliveryExtraMinutes'],
        'minimumBasket': json['minimumBasket'] == null ? undefined : json['minimumBasket'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'position': json['position'] == null ? undefined : json['position'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function UpdateDeliveryAreaRequestToJSON(json: any): UpdateDeliveryAreaRequest {
    return UpdateDeliveryAreaRequestToJSONTyped(json, false);
}

export function UpdateDeliveryAreaRequestToJSONTyped(value?: UpdateDeliveryAreaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': GetDeliveryAreas200ResponseInnerTypeToJSON(value['type']),
        'geometry': GetDeliveryAreas200ResponseInnerGeometryToJSON(value['geometry']),
        'deliveryFee': value['deliveryFee'],
        'deliveryExtraMinutes': value['deliveryExtraMinutes'],
        'minimumBasket': value['minimumBasket'],
        'enabled': value['enabled'],
        'position': value['position'],
        'color': value['color'],
    };
}

